module.exports = __webpack_public_path__ + "img/video_group.a2681299.svg";